import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { evChargingRouteDefinitions } from './EvChargingRouteDefinitions';
import { generatePageWithTabsRoute } from './routeGenerator';

const EvChargingRoutes: RouteObject = generatePageWithTabsRoute(
  'Analyze EV Charging Performance and User Behavior',
  BASE.EV_CHARGING,
  NESTED_ROUTES.EV_CHARGING.FACILITY,
  evChargingRouteDefinitions,
);

export default EvChargingRoutes;
